import React from 'react';

export const NothingFound: React.FC = () => (
  <svg width="161" height="125" viewBox="0 0 161 125" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2479_80667)">
      <path d="M30.0879 89.9443L36.4519 83.5804L53.4224 100.551L30.0879 89.9443Z" fill="#E3E1D8" />
      <rect
        width="24"
        height="111"
        transform="matrix(0.707107 0.707107 0.707107 -0.707107 36.4521 83.5801)"
        fill="#E3E1D8"
      />
    </g>
    <path
      d="M136.201 80.9455C139.31 82.7405 140.375 86.7158 138.58 89.8247C136.785 92.9336 132.81 93.9988 129.701 92.2039L101.555 75.9539L108.055 64.6955L136.201 80.9455Z"
      fill="#B8CAC4"
      stroke="#21282B"
      strokeWidth="3"
    />
    <rect
      x="25.799"
      y="69.1658"
      width="77"
      height="77"
      rx="38.5"
      transform="rotate(-60 25.799 69.1658)"
      fill="white"
      stroke="#21282B"
      strokeWidth="3"
    />
    <g clipPath="url(#clip1_2479_80667)">
      <rect x="39" y="15" width="80" height="80" rx="40" fill="white" />
      <g clipPath="url(#clip2_2479_80667)">
        <path d="M23.8457 81.8701L35.1594 70.5564L63.4437 98.8407L23.8457 81.8701Z" fill="#E3E1D8" />
        <rect
          width="40"
          height="100"
          transform="matrix(0.707107 0.707107 0.707107 -0.707107 35.1592 70.5566)"
          fill="#E3E1D8"
        />
      </g>
    </g>
    <rect x="40.5" y="16.5" width="77" height="77" rx="38.5" stroke="#21282B" strokeWidth="3" />
    <g clipPath="url(#clip3_2479_80667)">
      <rect x="56" y="31" width="48" height="48" rx="24" fill="#B8CAC4" />
      <circle
        cx="80.0004"
        cy="52.6"
        r="9.6"
        fill="white"
        stroke="#21282B"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="80.0002"
        cy="75.4002"
        rx="16.8"
        ry="13.2"
        fill="white"
        stroke="#21282B"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="80"
        cy="55"
        r="22.5"
        stroke="#21282B"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2479_80667">
        <rect
          width="24"
          height="120"
          fill="white"
          transform="matrix(0.707107 0.707107 0.707107 -0.707107 30.0879 89.9443)"
        />
      </clipPath>
      <clipPath id="clip1_2479_80667">
        <rect x="39" y="15" width="80" height="80" rx="40" fill="white" />
      </clipPath>
      <clipPath id="clip2_2479_80667">
        <rect
          width="40"
          height="116"
          fill="white"
          transform="matrix(0.707107 0.707107 0.707107 -0.707107 23.8457 81.8701)"
        />
      </clipPath>
      <clipPath id="clip3_2479_80667">
        <rect x="56" y="31" width="48" height="48" rx="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
